<div *ngIf="!loadingStatus">
  <div class="modal-header bg-primary p-0">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center flex-wrap p-2">
        <div class="d-none d-lg-flex align-items-center mr-2">
          <app-image-color
            [height]="'30px'"
            [width]="'40px'"
            [url]="'menu-icons/sows.svg'"
            [color]="'#ffffff'"
          ></app-image-color>
        </div>
        <div class="line bg-white d-none d-lg-flex"></div>
        <div class="text-left ml-2">
          <div class="flex-column">
            <h2 class="mb-0 d-flex align-items-start">
              {{ idPlanting ? ("plantings.title-2" | translate) : ("plantings.title" | translate) }}
              <span
                class="badge badge-light c-pointer help-badge ml-2"
                placement="bottom"
                ngbTooltip="{{ 'plantings.modal.tooltip' | translate }}"
                >?</span
              >
            </h2>
            <p class="m-0">{{ "plantings.modal.subtitle" | translate }}</p>
            <input
              [value]="textPonds(DataPonds)"
              [placeholder]="'plantings.modal.no-selected-ponds' | translate"
              class="w-100"
              style="border: none; background-color: transparent; color: white"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center" *ngIf="ButtonClosed">
        <h3 class="m-0 c-pointer" (click)="closedClick()">&times;</h3>
      </div>
    </div>
  </div>
  <div class="modal-body" style="margin-bottom: 30px">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="sowForm" (submit)="register(sowForm.value)">
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <ng-container *ngIf="seasons.length > 0">
                  <span>{{ "extended-harvest.season-name" | translate }}</span>
                  <select class="form-control" id="season" formControlName="season" name="season">
                    <option *ngFor="let item of seasons" [value]="item.id">{{item.name}}</option>
                  </select>
                </ng-container>
              </div>
              <div class="center" *ngIf="seasons.length === 0">
                <b> {{ "extended-harvest.no-seasons-registered" | translate }} </b>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <span>{{ "extended-harvest.planting-alias" | translate }}</span>
              <input
                type="text"
                id="alias"
                formControlName="alias"
                name="alias"
                class="form-control"
                [attr.disabled]="validateDisabled('alias')"
              />
              <small>{{ "extended-harvest.optional-field" | translate }}</small>
            </div>
            <div class="col-12">
              <span>{{'plantings.sow-date' | translate}}</span>
              <input
                type="date"
                formControlName="date"
                name="date"
                class="form-control"
                [attr.disabled]="validateDisabled('date') || validateTextBy7DaysLimit()"
              />
            </div>
            <div class="col-12 mt-2" *ngIf="sowForm.get('date').value">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <span>{{'feed.estimated-harvest' | translate}}</span>
                  <input
                    type="date"
                    formControlName="planned_end_date"
                    name="planned_end_date"
                    class="form-control"
                    (change)="changePlanned('planned_end_date')"
                    [attr.disabled]="validateDisabled('planned_end_date') "
                  />
                </div>
                <div class="col-12 col-lg-6">
                  <span>{{'feed.estimated-days' | translate}}</span>
                  <input
                    formControlName="planned_days"
                    type="number"
                    class="form-control"
                    (change)="changePlanned('planned_days')"
                    [attr.disabled]="validateDisabled('planned_days')"
                  />
                </div>

                <div class="col-12" *ngIf="validateTextByMonthLimit()">
                  <span class="text-danger"
                    >{{ "clients.cycles.planting-form.max-10-months" | translate }}</span
                  >
                </div>
              </div>
            </div>
            <ng-container *ngIf="DataPonds && DataPonds.length > 1">
              <div class="col-12 col-lg-6 mt-2">
                <span>{{'plantings.sow' | translate}} U/m2</span>
                <input
                  formControlName="planting_per_m2"
                  type="number"
                  class="form-control"
                  placeholder="{{ 'clients.pond.planting.larva-per-m2' | translate }}"
                  [attr.disabled]="validateDisabled('planting_per_m2')"
                />
              </div>

              <div class="col-12 col-lg-6 mt-2">
                <span>{{'plantings.sow-pond' | translate}}</span>
                <br />
                {{calculatelarvas(sowForm.value.planting_per_m2, DataPonds)}}
              </div>
            </ng-container>

            <ng-container *ngIf="DataPonds && DataPonds.length === 1">
              <div class="col-12 col-lg-6 mt-2">
                <span>{{'plantings.sow' | translate}} U/m2</span>
                <input
                  formControlName="planting_per_m2"
                  (change)="getGrub($event.target.value,1, DataPonds)"
                  type="number"
                  class="form-control"
                  placeholder="{{ 'clients.pond.planting.larva-per-m2' | translate }}"
                  [attr.disabled]="validateDisabled('planting_per_m2')"
                />
              </div>

              <div class="col-12 col-lg-6 mt-2">
                <span>{{'plantings.sow-pond' | translate}}</span>
                <input
                  formControlName="grubPond"
                  (change)="getGrub($event.target.value,2, DataPonds)"
                  type="number"
                  class="form-control"
                  placeholder="{{ 'clients.pond.planting.larva-per-pond' | translate }}"
                  [attr.disabled]="validateDisabled('grubPond')"
                />
              </div>
            </ng-container>

            <div class="col-12 col-lg-4 mt-2">
              <span>{{'plantings.initial' | translate}}.</span>
              <input
                formControlName="initial_weight"
                type="number"
                class="form-control"
                [attr.disabled]="validateDisabled('initial_weight')"
              />
            </div>

            <div class="col-12 col-lg-4 mt-2">
              <span>{{'clients.reports.larva' | translate}}</span>
              <input
                formControlName="larva_origin"
                type="text"
                class="form-control"
                placeholder="{{ 'clients.pond.planting.laboratory' | translate }}"
                [attr.disabled]="validateDisabled('larva_origin')"
              />
            </div>

            <div class="col-12 col-lg-4 mt-2">
              <div class="form-group">
                <span>{{'clients.reports.sow-type' | translate}}</span>
                <select
                  class="form-control"
                  id="type"
                  formControlName="type"
                  [attr.disabled]="validateDisabled('type')"
                >
                  <option value="0">{{'clients.reports.direct-sow' | translate}}</option>
                  <option value="1">{{'clients.reports.maternity-sow' | translate}}</option>
                </select>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-end">
              <button class="btn btn-success" type="submit" [disabled]="sowForm.invalid ">
                {{textButton ? textButton : ('general.finish' | translate)}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div style="height: 300px" class="center" *ngIf="loadingStatus">
  <app-spinner
    [vh]="'h-25vh'"
    [showSmall]="true"
    [errorText]="sowErrorMessage.errorMessage"
    [status]="sowErrorMessage.error"
    [type]="'Siembra'"
  >
  </app-spinner>
</div>
